import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { v4 as uuidv4 } from "uuid";
import "./Input.scss";

const Input = ({ type, value, disabled, unit, onChange, onSelect, onFocus, invalid, invalidText, ...props }) => {
  const [tooltipId] = useState(() => uuidv4());

  return (
    <div className="Input relative flex items-center">
      <input
        type={type}
        className={`text-xs py-0 px-1 w-20 transition-all duration-100
          ${disabled ? "text-gray-400 cursor-not-allowed" : ""}
          ${unit ? "pr-8" : ""}
          ${
            invalid
              ? "border-red-400 focus:border-red-400 ring-0 bg-red-100 focus:ring-0"
              : "focus:ring-0 focus:border-secondary border-gray-300"
          }
          `}
        value={value}
        onChange={onChange}
        onSelect={(event) => {
          //event.preventDefault();
          //event.target.select();
          if (onSelect !== null && onSelect !== undefined) onSelect(event);
        }}
        onFocus={(event) => {
          event.target.select();
          if (onFocus !== null && onFocus !== undefined) onFocus(event);
        }}
        disabled={disabled}
        data-tip
        data-for={tooltipId}
        {...props}
      />
      {invalid && (
        <ReactTooltip
          id={tooltipId}
          place="top"
          effect="solid"
          backgroundColor="#FFFFFF"
          textColor="rgb(31 41 55)"
          className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
        >
          {invalidText}
        </ReactTooltip>
      )}
      {unit && <span className="absolute right-2 select-none text-gray-400 font-light">{unit}</span>}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  unit: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  invalid: PropTypes.bool,
  invalidText: PropTypes.string
};

Input.defaultProps = {
  type: "text",
  value: "",
  disabled: false,
  unit: "",
  onChange: () => {},
  invalid: false,
  invalidText: "",
  onSelect: null
};

export default Input;
